// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/mail-report/components/mail-header/mail-header.less
// module id = 3977
// module chunks = 0